"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFbIcon = function SvgFbIcon(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.096 16.69c0-7.542 0-11.313 2.343-13.656S8.554.69 16.096.69c7.543 0 11.314 0 13.657 2.343s2.343 6.114 2.343 13.657c0 7.542 0 11.313-2.343 13.657-2.343 2.343-6.114 2.343-13.657 2.343-7.542 0-11.314 0-13.657-2.344C.096 28.005.096 24.233.096 16.691Z",
    fill: "url(#FbIcon_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.362 21.08v11.598h5.353V21.08h3.57l.713-4.46h-4.283v-3.123c0-1.25.446-2.23 2.41-2.23h2.05V7.16c-1.158-.178-2.408-.356-3.567-.356-3.659 0-6.246 2.23-6.246 6.244v3.57H9.347v4.46h4.015Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "FbIcon_svg__a",
    x1: 16.096,
    y1: 0.691,
    x2: 16.096,
    y2: 32.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ADFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0164E1"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgFbIcon);
var _default = exports["default"] = Memo;